import { useEffect } from "react";
import { PageHeader } from "../components/lendx/PageHeader";
import { WhyLendXSection, FundingJourney } from "../components/lendx/WhyJourney";
import { LenderNetwork } from "../components/lendx/LenderNetwork";
import { CTABanner } from "../components/lendx/CTABanner";
import { applySEO } from "../lib/scroll";

export default function WhyLendXPage() {
  useEffect(() => {
    applySEO(
      "Why LendX | Strategic Loan Advisory & End-to-End Funding Support",
      "Finance is more than just a loan — it's a strategy. Discover LendX's expert guidance, tailored solutions, market understanding, and relationship-based approach."
    );
  }, []);

  return (
    <main data-testid="why-lendx-page">
      <PageHeader
        overline="Why LendX"
        title="Advisory First. Transactions Second."
        sub="We build long-term financial relationships — guiding clients through structure, documentation, and funding coordination."
        testId="why-lendx"
      />
      <WhyLendXSection />
      <FundingJourney />
      <LenderNetwork />
      <CTABanner />
    </main>
  );
}
